<app-offcanvas-base [returnUrl]="returnUrl">
  <ng-container title> Remove employee </ng-container>

  <ng-container body>
    @if (employeeFullName) {
      <div class="mt-5">
        <div class="text-center mb-4">
          <img
            src="../../../../../../assets/graphics/remove_person.svg"
            alt=""
            width="150" />
        </div>
        <div
          class="h3"
          id="title">
          Are you sure you want to remove {{ employeeFullName }}?
        </div>
        <p class="lead">To remove this user, please select a new approver user to approve fund requests.</p>
        <div class="mb-3 mt-4">
          <label
            for="typeahead"
            class="form-label">
            Choose a new approver
            <i
              class="iconoir-info-circle"
              placement="bottom"
              [ngbTooltip]="tipContent"></i>
            <ng-template #tipContent>
              Why do I need a new approver? This is an approver for one or multiple card top-up rules and each rule
              requires at least one approver to ensure seamless spend management.
            </ng-template>
          </label>
          @if (approverOptions.length > 0) {
            <ng-select
              id="typeahead"
              [(ngModel)]="selectedReplacement"
              [searchable]="true"
              [placeholder]="'Search an approver'">
              @for (item of approverOptions; track item.value) {
                <ng-option [value]="item.value">
                  {{ item.option }}
                </ng-option>
              }
            </ng-select>
          }
        </div>
      </div>
      <div class="row offcanvas-buttons">
        <div class="col-12 col-sm-auto">
          <app-offcanvas-cancel-btn [returnUrl]="returnUrl"></app-offcanvas-cancel-btn>
        </div>
        <div class="col-12 col-sm-auto ms-sm-auto">
          <button
            type="button"
            [disabled]="!selectedReplacement"
            (click)="onReplaceApprover()"
            class="btn btn-primary">
            Update
          </button>
        </div>
      </div>
    } @else {
      <app-loader></app-loader>
    }
  </ng-container>
</app-offcanvas-base>
